"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Checkbox = /*#__PURE__*/_react.default.forwardRef(({
  ...props
}, ref) => {
  const [value, setValue] = (0, _react.useState)(props.checked ? true : false);
  const {
    checked,
    disabled,
    className,
    disabledHoverState,
    nomargin,
    child,
    type,
    name,
    onChange,
    onClick,
    id,
    children,
    ...restProps
  } = props;
  (0, _react.useEffect)(() => {
    setValue(props.checked ? true : false);
  }, [props.checked]);
  const handleChange = e => {
    if (props.disabled) return;
    setValue(!value);
    props.onChange && props.onChange(e);
  };
  return (0, _jsxRuntime.jsxs)("label", {
    "aria-label": props['aria-label'],
    htmlFor: id,
    className: className,
    css: theme => [_styles.styles.default(theme), disabled && _styles.styles.disabled(theme, disabledHoverState), nomargin && _styles.styles.nomargin, child && _styles.styles.child, type === 'subtle' && _styles.styles.subtle(theme)],
    onClick: e => e.stopPropagation(),
    children: [(0, _jsxRuntime.jsx)("input", {
      ref: ref,
      type: "checkbox",
      role: "checkbox",
      "aria-checked": value,
      checked: value,
      value: props.value,
      name: name,
      id: id,
      disabled: disabled,
      onClick: onClick,
      onChange: handleChange,
      ...restProps
    }), (0, _jsxRuntime.jsx)("span", {}), children]
  });
});
var _default = exports.default = Checkbox;